import { http } from "../base"


export async function countDashboard(tenantId, username) {
    console.log("enter countDashboard",tenantId, username);
    try {
        const response = await http.get(
            `/aics/dashboard/count_by_tenant_username?tenantId=${tenantId}&userName=${username}`
        );
        return response;
    } catch (error) {
        return error;
    }
}

    export async function getUserPermission(username) {
          console.log("getUserPermission",username);
          const response = await http.get(
            `/aics/user_permission/${username}`,
          );
            console.log(response);
            // 统一处理响应格式
            if (response==null || response.status !== 200) {
              throw new Error(response.data.message || '获取配置信息失败');
            }
            return response.data;
    }      